import { useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { faqs } from '../data/webServicesData';
import FaqSection from '../components/services/FaqSection';

export default function Faq() {
  const { t } = useLanguage();

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqs.map((f) => ({
        '@type': 'Question',
        name: f.q.en,
        acceptedAnswer: { '@type': 'Answer', text: f.a.en },
      })),
    });
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="pt-24 md:pt-28" data-testid="faq-page">
      <div className="text-center px-6">
        <p className="accent-tag justify-center">{t('faqPageTag')}</p>
      </div>
      <FaqSection />
    </div>
  );
}
